"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merge = exports.makeId = exports.isProduction = void 0;
const tslib_1 = require("tslib");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
const is_plain_object_1 = tslib_1.__importDefault(require("is-plain-object"));
/**
 * Check if the project is running in production mode. Returns 'true' if it is.
 */
function isProduction() {
    // Web
    if (process && process.env && process.env.NODE_ENV) {
        return process.env.NODE_ENV === 'production';
    }
    // react-native
    // eslint-disable-next-line no-undef
    if (__DEV__) {
        return false;
    }
    return true;
}
exports.isProduction = isProduction;
/**
 * Creates a unique ID.
 * @param chars Number of characters. Defaults to 5
 */
function makeId(length = 8) {
    let str = '';
    for (let i = 1; i < length + 1; i = i + 8) {
        str += Math.random().toString(36).substr(2, 10);
    }
    return `_${str}`.substr(0, length);
}
exports.makeId = makeId;
/**
 * Deep merges 2 objects. Nested fields are only merged if they are plain objects or arrays.
 * @param x
 * @param y
 */
function merge(x, y) {
    return deepmerge_1.default(x, y, {
        isMergeableObject: (i) => is_plain_object_1.default(i) || Array.isArray(i),
    });
}
exports.merge = merge;
